<template>
    <div class="input-content">
        <div class="user-input-textarea-wrapper" ref="user-input-textarea-wrapper">
            <a-mentions
                rows="5"
                autoFocus
                v-model="prompt"
                :prefix="['/']"
                :disabled="typing"
                class="user-input-textarea" :placeholder="placeholder"
                @keydown.native.alt.enter.prevent="wrap"
                @select="selectValue"
                @blur="handleFocus(false)"
                @focus="handleFocus(true)"
                @keydown.native.enter.prevent.exact="ask"
                :getPopupContainer="() => $refs['user-input-textarea-wrapper']">
                <a-mentions-option :value="item.title" :key="item.value" v-for="item in mentionsList">
                    {{ item.title }}
                </a-mentions-option>
            </a-mentions>
        </div>
        <div class="textarea-right">
            <mic :prompt.sync="prompt"></mic>
            <img class="send" :class="{'disabled': !prompt}" src="@/theme/images/icons/icon_send.svg" @click="send()" title="发送" />
        </div>
    </div>
</template>

<script>
import mic from './mic.vue';
import MODEL_LIST from '@/app/constant/MODEL_LIST.js';
export default {
    name: 'gpt-chatbox-flow-prediction',
    components: { mic },
    data () {
        return {
            prompt: '',
            recording: false,
            MODEL_LIST
        };
    },
    props: {
        /**
         * 是否正在输入
         */
        typing: {
            type: Boolean,
            default: false
        },
        /**
         * 输入框的占位文字
         */
        placeholder: {
            type: String,
            default: ''
        },
        /**
         * 输入框的内容
         */
        input: {
            type: String,
            default: ''
        },
        /**
         * 提示词模板的内容
         */
        promptTemplate: {
            type: Object,
            default: null
        }
    },
    computed: {
        mentionsList () {
            return [
                ...this.MODEL_LIST
            ];
        }
    },
    watch: {
        input (val) {
            this.prompt = val;
        },
        prompt (val) {
            if (val && val[0] === '/') {
                this.$emit('showModel');
            }
            if (val && val.indexOf('/?') > -1) {
                this.$bus.$emit('openAiModel');
                this.prompt = this.prompt.replace('/?', '');
            }
        }
    },
    mounted () {
        this.prompt = this.input;
    },
    methods: {
        handleFocus (focus) {
            this.$emit('focus-typing', focus);
        },
        send () {
            if (this.prompt.trim() === '') {
                this.$message.error('请输入内容后再发送');
                return;
            }
            let model = 'COP';
            let input = this.prompt;
            let prompt = this.getPrompt(input);
            let answerPrefix = '```gpt-chatbox-flow-prediction\n';
            // input是用户输入的内容，prompt是发给机器人的内容，answerPrefix是回答前缀（用于限定返回内容用什么进行处理）
            let ask = { model, input, prompt, answerPrefix, nospeech: true };
            this.$emit('inputAsk', ask);
            this.prompt = '';
        },
        wrap (event) {
            if (event.altKey) {
                this.prompt = this.prompt + '\n';
            }
        },
        ask (event) {
            if (event && !event.altKey) {
                this.send();
            }
        },
        getPrompt (input) {
            if (!this.promptTemplate) throw new Error('未找到提示词模板');
            let prompt = this.promptTemplate.content || '';
            prompt = prompt.replace(/\{input\}/g, input);
            return prompt;
        },
        selectValue (data) {
            this.$emit('setModel', data.value);
            this.prompt = this.prompt.replace(`/${data.value}`, '');
        }
    }
};
</script>

<style scoped lang="scss">
@import './gpt-chatbox-common.scss';
</style>
